import { render, staticRenderFns } from "./pose-detection.vue?vue&type=template&id=6d575a61&scoped=true"
import script from "./pose-detection.vue?vue&type=script&lang=js"
export * from "./pose-detection.vue?vue&type=script&lang=js"
import style0 from "./pose-detection.vue?vue&type=style&index=0&id=6d575a61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d575a61",
  null
  
)

export default component.exports